export function parseCsvPreview(input = '') {
  const text = String(input || '').replace(/^\uFEFF/, '');
  const rows = [];
  let row = [];
  let cell = '';
  let quoted = false;
  for (let index = 0; index < text.length; index += 1) {
    const char = text[index];
    if (quoted) {
      if (char === '"' && text[index + 1] === '"') {
        cell += '"';
        index += 1;
      } else if (char === '"') quoted = false;
      else cell += char;
    } else if (char === '"') quoted = true;
    else if (char === ',') { row.push(cell); cell = ''; }
    else if (char === '\n') {
      row.push(cell.replace(/\r$/, ''));
      if (row.some((value) => value !== '')) rows.push(row);
      row = [];
      cell = '';
    } else cell += char;
  }
  row.push(cell.replace(/\r$/, ''));
  if (row.some((value) => value !== '')) rows.push(row);
  if (quoted) throw new Error('The CSV contains an unclosed quoted value.');
  if (rows.length < 2) throw new Error('The CSV needs a header and at least one member.');
  const headers = rows[0].map((value) => value.trim());
  return {
    headers,
    rows: rows.slice(1).map((values, index) => ({
      rowNumber: index + 2,
      values: Object.fromEntries(headers.map((header, column) => [header, String(values[column] || '').trim()])),
    })),
  };
}

export function distinctColumnValues(parsed, header) {
  if (!header) return [];
  return Array.from(new Set((parsed?.rows || []).map((row) => row.values?.[header]?.trim()).filter(Boolean))).sort((a, b) => a.localeCompare(b));
}

export function buildMemberImportTemplate(now = new Date()) {
  const paidThrough = new Date(now);
  paidThrough.setUTCDate(paidThrough.getUTCDate() + 90);
  const rows = [
    ['First name', 'Last name', 'Member email', 'Membership type', 'Paid through', 'Phone', 'Date of birth', 'Address', 'Tags'],
    ['Example', 'Member', 'member@example.com', 'Adult', [paidThrough.getUTCDate(), paidThrough.getUTCMonth() + 1, paidThrough.getUTCFullYear()].map((part, index) => index < 2 ? String(part).padStart(2, '0') : String(part)).join('/'), '', '', '', ''],
  ];
  // BOM preserves headings in Excel; CSV quoting does not prevent spreadsheet date conversion.
  return '\uFEFF' + rows.map(row => row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(',')).join('\r\n') + '\r\n';
}
